/**
 * Describes the shape of a single action.
 */
export interface ICalendarStateAction {
    type: ActionType;
    value?: any;
}

/**
 * Represents all of the actions that a user can perform on the search page. It's a class so that a dev can extend it.
 */
export class ActionType {
    static get NextMonth() {
        return "NextMonth";
    }
    static get PreviousMonth() {
        return "PreviousMonth";
    }
    static get AddDays() {
        return "AddDays";
    }
    static get SetMonth() {
        return "SetMonth";
    }
    static get GoToMonth() {
        return "GoToMonth";
    }
    static get SetDates() {
        return "SetDates";
    }
    static get UpdateEventFilter() {
        return "UpdateEventFilter";
    }
    static get EventApiError() {
        return "EventApiError";
    }
    static get RemoveEventFilter() {
        return "RemoveEventFilter";
    }
    static get RemoveAllEventFilters() {
        return "RemoveAllEventFilters";
    }
    static get UpdateEvents() {
        return "UpdateEvents";
    }
    static get ChangeProductionSeasonFilter() {
        return "ChangeProductionSeasonFilter";
    }
    static get BrowserNavigated() {
        return "BrowserNavigated";
    }
    static get EventUpdated() {
        return "EventUpdated";
    }
    static get RequestEvents() {
        return "RequestEvents";
    }
    static get UpdateSettings() {
        return "UpdateSettings";
    }
    static get RequestText() {
        return "RequestText";
    }
    static get ReceiveText() {
        return "ReceiveText";
    }
    static get ErrorApiText() {
        return "ErrorApiText";
    }
    static get RequestPromoCodeApply() {
        return "RequstPromoCodeApply";
    }
    static get ReceivePromoCodeApply() {
        return "ReceivePromoCodeApply";
    }
    static get ErrorPromoCodeApply() {
        return "ErrorPromoCodeApply";
    }
    static get RequestPromoCodeRemove() {
        return "RequestPromoCodeRemove";
    }
    static get ReceivePromoCodeRemove() {
        return "ReceivePromoCodeRemove";
    }
    static get ReceivePromoCodeGet() {
        return "ReceivePromoCodeGet";
    }
    static get ErrorPromoCodeRemove() {
        return "ErrorPromoCodeRemove";
    }
    static get SetToMobile() {
        return "SetToMobile";
    }
    static get SetToDesktop() {
        return "SetToDesktop";
    }
    static get SetToGrid() {
        return "SetToGrid";
    }
    static get SetToList() {
        return "SetToList";
    }
    static get UpdatePromoCode() {
        return "UpdatePromoCode";
    }
    static get ShowPromo() {
        return "ShowPromo";
    }
    static get WaitForImage() {
        return "WaitForImage";
    }
    static get ImageHasLoaded() {
        return "ImageHasLoaded";
    }
}